// extracted by mini-css-extract-plugin
export default {"Box":"shared-issue-viewer-module__Box__R6fJqwa","Box_1":"shared-issue-viewer-module__Box_1__lXDqLF9"};